<div class="currency-input-wrapper">
  @if (inputFieldConfig?.inputStyle === 'large') {
    <div class="currency-input-large">
      <div class="d-flex gap-1 align-items-center">
        <label
          *ngIf="inputFieldConfig.label && labelType !== labelTypeOptions.PLACEHOLDER"
          [for]="inputFieldConfig.name"
          [class.labelActive]="isInputOnFocus"
          class="labelText labelIdle labelConfig"
          >{{ inputFieldConfig.label }}</label
        >
        @if (
          inputLabelTooltipText?.length &&
          labelType !== labelTypeOptions.FLOATING &&
          labelType !== labelTypeOptions.PLACEHOLDER
        ) {
          <finxone-platform-tooltip
            [content]="inputLabelTooltipText"
            [textStyleClass]="tooltipTextStyleClass"
            [borderRadiusClass]="tooltipBorderRadiusClass"
          ></finxone-platform-tooltip>
        }
      </div>

      <div class="is-center gap-1">
        <div [class]="textStyleClass">
          {{ inputFieldConfig?.currencyFormat === 'symbol' ? currency?.symbol : currency?.code }}
        </div>
        <ng-container *ngTemplateOutlet="inputTemplate; context: { customInput: true }"></ng-container>
      </div>
    </div>
  } @else {
    <finxone-input
      [class]="inputFieldConfig?.currencyFormat === 'symbol' ? 'pl-5' : 'pl-8'"
      [inputFieldConfig]="inputFieldConfig"
      [id]="inputFieldConfig.name"
      [name]="inputFieldConfig.name"
      [parentControl]="control"
      [label]="labelType !== labelTypeOptions.PLACEHOLDER ? (inputFieldConfig?.label ?? '') : ''"
      [showErrors]="true"
      [customInputTemplate]="inputTemplate"
      [validationConfig]="validationConfig"
      [spaceBetweenElementUnit]="inputFieldConfig?.spaceBetweenElementUnit ?? ''"
      [spaceBetweenElementValue]="inputFieldConfig?.spaceBetweenElementValue ?? 0"
      [inputLabelTooltipText]="inputFieldConfig?.inputLabelTooltipText ?? ''"
      [(isInputOnFocus)]="isInputOnFocus"
    >
      <ng-container prefix>
        <div class="position-absolute top-0 bottom-0 left-2 is-center">
          {{ inputFieldConfig?.currencyFormat === 'symbol' ? currency?.symbol : currency?.code }}
        </div>
      </ng-container>
    </finxone-input>
  }
  <!-- Info  Template -->
  <ng-container *ngIf="infoText">
    <div [innerHTML]="infoText | safeHtml"></div>
  </ng-container>
</div>
@if (inputFieldConfig?.inputStyle === 'large') {
  <div *ngIf="showErrors && control?.invalid && control?.touched" class="error-container" role="alert">
    <div class="is-vertical-align mt-1">
      <ng-container *ngFor="let validator of validationConfig">
        <small *ngIf="control?.hasError(validator.type)" class="typog-xs text-error">
          {{ getErrorMessageForField(validator) }}
        </small>
      </ng-container>
    </div>

    <!-- Custom Error Template -->
    <ng-container
      *ngIf="customErrorTemplate"
      [ngTemplateOutlet]="customErrorTemplate"
      [ngTemplateOutletContext]="{
        $implicit: {
          control: control,
          errors: control?.errors,
        },
      }"
    ></ng-container>
  </div>
}
<ng-template #inputTemplate let-customInput="customInput">
  <input
    [ngClass]="
      customInput
        ? textStyleClass + ' text-center bg-transparent' + borderRadiusClass
        : 'inputField' +
          ' ' +
          (inputFieldConfig.currencyFormat === 'symbol' ? 'pl-5' : 'pl-8') +
          ' ' +
          borderRadiusClass
    "
    type="text"
    [autocomplete]="disableAutocomplete ? 'nope' : undefined"
    [name]="inputFieldConfig.name"
    [id]="inputFieldConfig?.id ?? id"
    [value]="isInputOnFocus ? value : formattedValue"
    [formControl]="control"
    inputMode="decimal"
    (input)="setDynamicWidth()"
    (keyup)="handleOnChange($event)"
    (blur)="handleBlurEvent()"
    (focus)="onTouched(); isInputOnFocus = true"
    [style.color]="isInputOnFocus ? inputActiveColor : inputIdleColor"
    [placeholder]="customInput ? '0.00' : labelType === labelTypeOptions.STATIC ? '0.00' : ''"
    [attr.maxlength]="maxLength"
    [attr.autofocus]="isInputOnFocus"
  />
</ng-template>
